import React, { useCallback } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';

import ErrorBoundary from 'components/core/ErrorBoundary.component';
import FLAG from 'config/flag.singleton';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import call from 'utils/functions/call.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import parseJson from 'utils/parsers/parseJson';

const CTAG = 'DndContext';
const L = logger(CTAG);

const USE_SPAM_LOG = fromAnyToBool(FLAG.loggerSpam);

const DndContext = ({ tag: tagFromProps, onDragStart, onDragEnd, ...extra }) => {
  const tag = fromAnyToTrimmed(tagFromProps);
  const FTAG = `${tag}${CTAG}`;

  const handleDragStart = useCallback(
    (ev, ...extra) => {
      if (USE_SPAM_LOG) {
        const { draggableId, source } = asObject(ev);
        const idDrag = parseJson(draggableId);
        const idDragType = asObject(idDrag).type;
        const idDropSource = parseJson(asObject(source).droppableId);
        const ids = { idDrag, idDropSource };
        L.debug('()', 'handleDragStart()', tag, idDragType, '!!!', ids, { ev });
      }
      return call(`${FTAG}.onDragStart`, onDragStart, ev, ...extra);
    },
    [FTAG, onDragStart, tag],
  );

  const handleDragEnd = useCallback(
    (ev, ...extra) => {
      if (USE_SPAM_LOG) {
        const { draggableId, source, destination } = asObject(ev);
        const idDrag = parseJson(draggableId);
        const idDragType = asObject(idDrag).type;
        const idDropSource = parseJson(asObject(source).droppableId);
        const idDropTarget = parseJson(asObject(destination).droppableId);
        const idDropTargetType = asObject(idDropTarget).type;
        const ids = { idDrag, idDropSource, idDropTarget };
        L.debug('()', 'handleDragEnd()', tag, idDragType, '->', idDropTargetType, ids, { ev });
      }
      return call(`${FTAG}.onDragEnd`, onDragEnd, ev, ...extra);
    },
    [FTAG, onDragEnd, tag],
  );

  return (
    <ErrorBoundary strat="console" tag={tag}>
      <DragDropContext {...extra} onDragEnd={handleDragEnd} onDragStart={handleDragStart} />
    </ErrorBoundary>
  );
};

export default DndContext;
